import Keycloak from "keycloak-js";
import { getServiceUrls } from "./services/serviceUrls";

export const keycloak = () => {
  const SERVICE_URL = getServiceUrls();
  return new Keycloak({
    url: SERVICE_URL.REACT_APP_KEYCLOAK_URL,
    realm: SERVICE_URL.REACT_APP_KEYCLOAK_REALM,
    clientId: SERVICE_URL.REACT_APP_KEYCLOAK_CLIENT_ID,
  });
};
